import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { AreaLayout } from "@/pages/area/AreaLayout";
import { AppIcon } from "@/components/AppIcon";
import { Button } from "@/components/ui/button";
import { ExternalLink, Construction } from "lucide-react";

export default function AreaDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [a, setA] = useState(null);

  useEffect(() => {
    api.get(`/area/areas/${id}`).then(({ data }) => setA(data)).catch(() => navigate("/area-riservata"));
  }, [id, navigate]);

  if (!a) return <AreaLayout title="Caricamento…"><div /></AreaLayout>;

  return (
    <AreaLayout subtitle={a.client_name} title={a.title}>
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm p-6 max-w-3xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="h-12 w-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${a.color}1A`, color: a.color }}>
            <AppIcon name={a.icon} className="h-6 w-6" />
          </div>
          <div>
            <div className="font-heading text-lg font-medium text-slate-900">{a.title}</div>
            <div className="text-sm text-slate-500">{a.client_name}</div>
          </div>
        </div>
        {a.description && <p className="text-slate-600 mb-4">{a.description}</p>}

        {a.internal_route ? (
          <Button data-testid="area-open-internal" onClick={() => navigate(a.internal_route)} className="brand-gradient text-white border-0">
            <ExternalLink className="h-4 w-4 mr-2" /> Apri il gestionale
          </Button>
        ) : a.external_url ? (
          <Button data-testid="area-open-external" onClick={() => window.open(a.external_url, "_blank", "noopener,noreferrer")} className="brand-gradient text-white border-0">
            <ExternalLink className="h-4 w-4 mr-2" /> Apri applicazione/archivio
          </Button>
        ) : a.content ? (
          <div className="prose prose-slate max-w-none whitespace-pre-wrap text-slate-700 text-sm">{a.content}</div>
        ) : (
          <div className="rounded-lg border border-dashed border-slate-300 bg-slate-50 p-6 flex items-start gap-3">
            <Construction className="h-5 w-5 text-amber-500 mt-0.5" />
            <div>
              <div className="font-medium text-slate-900">Area in allestimento</div>
              <p className="text-sm text-slate-500">Questo spazio è pronto e verrà alimentato con le specifiche dell'attività (archivio, app di gestione, convenzione, ecc.).</p>
            </div>
          </div>
        )}
      </div>
    </AreaLayout>
  );
}
